module.exports = __webpack_public_path__ + "img/10.f4710f80.png";